export default gaEventsService

/** @ngInject */
function gaEventsService($window) {
    const newEvent = function (eventAction, eventLabel) {
        eventLabel = eventLabel || eventAction
        // GA EVENT
        // initial GA event Start subscription
        const campainId = localStorage.id_campaign || 'default'
        $window.ga('send', {
            hitType: 'event',
            eventCategory: campainId,
            eventAction,
            eventLabel: `${campainId}-${eventLabel}`,
            transport: 'beacon',
        })
        return true
    }

    return {
        newEvent,
    }
}



// WEBPACK FOOTER //
// ./src/services/gaEvents/gaEventsService.js